import { createContext, FC, PropsWithChildren, useContext, useMemo, useState } from 'react'

type PdfDownloadMode = {
  isPdfDownloadMode: boolean
  setPdfDownloadMode: (status: boolean) => void
}

const PdfDownloadModeContext = createContext<PdfDownloadMode>({} as PdfDownloadMode)

export const PdfDownloadModeContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isPdfDownloadMode, setPdfDownloadMode] = useState(false) // When downloading PDF, this is set to true

  const state: PdfDownloadMode = useMemo(
    () => ({
      isPdfDownloadMode,
      setPdfDownloadMode,
    }),
    [isPdfDownloadMode]
  )

  return <PdfDownloadModeContext.Provider value={state}>{children}</PdfDownloadModeContext.Provider>
}

export const usePdfDownloadMode: () => PdfDownloadMode = () => {
  const context = useContext(PdfDownloadModeContext)
  if (!context) {
    throw new Error('Must use usePdfDownloadMode in PdfDownloadModeContext')
  }
  return context
}
